import AddDepartamento from 'components/departamentos/AddDepartamento'
import React from 'react'
import { Col, Row } from 'reactstrap'

const ViewAddDepartamento = () => {
  return (
    <>
        <Row>
            <Col>
                <AddDepartamento></AddDepartamento>
            </Col>
        </Row>

    </>
  )
}

export default ViewAddDepartamento